export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const MESSAGE_SHOW = "MESSAGE_SHOW";
export const MESSAGE_HIDE = "MESSAGE_HIDE";
export const SET_ALERT = "SET_ALERT";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const UPDATE_TOKEN = "UPDATE_TOKEN";